import axiosInstance from '../RestClient';

const BASE_URI = '/accounts';
class AccountService {
	async list(onlyIds) {
		const uri = `${BASE_URI}/`;
		const response = await axiosInstance.get(uri, { params: { onlyIds } });
		return response;
	}

	async listForAssets() {
		const response = await axiosInstance.get(`${BASE_URI}/forAssets`);
		return response;
	}

	async listWithAssets() {
		const uri = `${BASE_URI}/`;
		const response = await axiosInstance.get(uri, { params: { withAssets: true } });
		return response;
	}

	// Account chains (SHOW_ACCOUNT_CHAIN)
	async getChain(recordId) {
		const response = await axiosInstance.get(`${BASE_URI}/${recordId}/chain`);
		return response;
	}

	async setContinuesFrom(recordId, accountId) {
		const response = await axiosInstance.put(`${BASE_URI}/${recordId}/continues-from`, { accountId: accountId || null });
		return response;
	}

	async getDetails(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async create(payload) {
		const response = await axiosInstance.post(`${BASE_URI}/`, payload);
		return response;
	}

	async edit(recordId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/${recordId}`, payload);
		return response;
	}

	async delete(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.delete(uri);
		return response;
	}

	// Everything the cascade delete would destroy: main entities itemised,
	// system-generated ones as counts, plus any cross-account conflict that
	// blocks the deletion outright.
	async getDeletionPreview(recordId) {
		const uri = `${BASE_URI}/${recordId}/deletion-preview`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async search(query) {
		const uri = `${BASE_URI}/search?${query}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getDebtsForAccountId(recordId) {
		const uri = `${BASE_URI}/accountDebts/${recordId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getCreditsForAccountId(recordId) {
		const uri = `${BASE_URI}/accountCredits/${recordId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getBalancePDF(accountId, month, type, { includePaidBills = true, includePaidDues = true } = {}) {
		const uri = `${BASE_URI}/${accountId}/balance/pdf?month=${month}&type=${type}&includePaidBills=${includePaidBills}&includePaidDues=${includePaidDues}`;
		const response = await axiosInstance.get(uri, { responseType: 'blob' });
		return response;
	}

	async sendBalanceEmail(accountId, month, type, email, { includePaidBills = true, includePaidDues = true } = {}) {
		const uri = `${BASE_URI}/${accountId}/balance/sendEmail`;
		const response = await axiosInstance.post(uri, { month, type, email, includePaidBills, includePaidDues });
		return response;
	}

	async createBalanceShareLink(accountId, month, type, { includePaidBills = true, includePaidDues = true } = {}) {
		const uri = `${BASE_URI}/${accountId}/balance/share`;
		const response = await axiosInstance.post(uri, { month, type, includePaidBills, includePaidDues });
		return response;
	}

	async getBalanceClientPhone(accountId, type) {
		const uri = `${BASE_URI}/${accountId}/balance/client-phone?type=${type}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async listForDashboard() {
		const uri = `${BASE_URI}/dashboard`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async sendEstadoSituacionReport(payload) {
		const uri = `${BASE_URI}/reports/estado-situacion/sendEmail`;
		const response = await axiosInstance.post(uri, payload);
		return response;
	}
}
export default new AccountService();
